const FormResources = {

    form_data:{
        associate_id: '',
        number:       '',
        description:  '',
        notes:        '',
        show_minutes: 1,
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Number #:',
            model_name: 'number',
            ref:        'number_input',
            ref_alt:    'number_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Associate:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
            label: 'associate_name'
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Show Scheduled Minutes:',
            model_name: 'show_minutes',
            ref:        'show_minutes_input',
            ref_alt:    'show_minutes_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Total minutes',
            model_name: 'minutes',
            ref:        'minutes_input',
            ref_alt:    'minutes_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Notes:',
            model_name: 'notes',
            ref:        'note_input',
            ref_alt:    'note_input_alt',
            required:   false,
        },
    ],
    scheduled_form_data:{
        building_id: '',
        level_id: '',
        area_id: '',
        task_id: '',
        all_rooms: false,
    },

    scheduled_form_format:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Level:',
            model_name: 'level_id',
            ref:        'level_id_input',
            ref_alt:    'level_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Area:',
            model_name: 'area_id',
            ref:        'area_id_input',
            ref_alt:    'area_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Project Task:',
            model_name: 'task_id',
            ref:        'project_task_id_input',
            ref_alt:    'project_task_id_input_alt',
            required:   false,
        },
    ],

    week_form_data: {
        sunday:     false,
        monday:     false,
        tuesday:    false,
        wednesday:  false,
        thursday:   false,
        friday:     false,
        saturday:   false,
    },

}

export default FormResources;